import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './ui/FadeIn';
import { Book, Scale, Map, Smartphone, LayoutTemplate } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    icon: <Book className="w-6 h-6" data-id="element-183" />,
    title: 'Guía Principal "Legado de Sabores" (PDF)',
    desc: 'El manual completo con el sistema de rescate de sazón.'
  }, {
    icon: <Scale className="w-6 h-6" data-id="element-184" />,
    title: 'Matriz Tanteo-a-Tabla',
    desc: 'La herramienta para convertir tus "pizcas" en medidas exactas.'
  }, {
    icon: <Map className="w-6 h-6" data-id="element-185" />,
    title: 'El Mapa de Momentos Sagrados',
    desc: 'Una estructura para organizar tus recetas por emociones y celebraciones.'
  }, {
    icon: <Smartphone className="w-6 h-6" data-id="element-186" />,
    title: 'Guía de Digitalización Fácil',
    desc: 'Instrucciones simples para usar tu celular como tu mejor archivo histórico.'
  }, {
    icon: <LayoutTemplate className="w-6 h-6" data-id="element-187" />,
    title: 'Plantilla de Libro de Cocina Familiar',
    desc: 'Un diseño listo para llenar y compartir con los tuyos.'
  }];
  return <section className="py-24 bg-heritage-cream bg-paper-texture" data-id="element-188">
      <div className="max-w-5xl mx-auto px-6 content-relative" data-id="element-189">
        <FadeIn data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-191">
            Lo que obtienes hoy
          </h2>
        </FadeIn>

        <StaggerContainer className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-192">
          {deliverables.map((item, idx) => <StaggerItem key={idx} className={`bg-white p-8 rounded-xl shadow-sm border border-heritage-beige ${idx === 0 ? 'md:col-span-2 lg:col-span-3 bg-heritage-beige/30' : ''}`} data-id="element-193">
              <div className="w-12 h-12 rounded-full bg-heritage-gold/20 flex items-center justify-center text-heritage-coffee mb-6" data-id="element-194">
                {item.icon}
              </div>
              <h3 className="font-serif font-semibold text-xl mb-3 text-heritage-terracotta" data-id="element-195">
                {item.title}
              </h3>
              <p className="text-heritage-coffee/80" data-id="element-196">{item.desc}</p>
            </StaggerItem>)}
        </StaggerContainer>
      </div>
    </section>;
}